module.exports = {"pathContext":{"slug":"/en/","langKey":"en"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/en.json
// module id = 1283
// module chunks = 253844482878330